import {
  all,
  call,
  put,
  select,
  takeEvery,
  takeLatest,
} from 'redux-saga/effects';
import request from 'utils/request';
import {makeSelectUserToken} from 'reducers/selectors/userSelectors';
import {getQueryString} from 'utils/queryString';
import {addParameterToURL} from 'helpers';
import {
  ADD_CATEGORY,
  AddCategoryFailed,
  AddCategorySuccess,
  DELETE_CATEGORY,
  deleteCategorySuccess,
  FETCH_CATEGORIES,
  FETCH_FOLDER,
  FETCH_FOLDERS,
  fetchCategoriesFailed,
  fetchCategoriesSuccess,
  fetchFolderFailed,
  fetchFoldersFailed,
  fetchFoldersSuccess,
  fetchFolderSuccess,
  LINK_LOGO,
  linkLogoFailed,
  linkLogoSuccess,
  UPDATE_CATEGORY,
  UPDATE_SEQUENCE,
  updateCategoryFailed,
  updateCategorySuccess,
  updateSequenceFailed,
  updateSequenceSuccess,
} from 'actions/categoryActions';

const requestUrl = `category`;

function* fetchCategories(action) {
  let url = requestUrl;
  if (action.kind) {
    url = addParameterToURL(url, `type=${action.kind}`);
  }
  if (action.pageFolderId) {
    url = addParameterToURL(url, `pageFolderId=${action.pageFolderId}`);
  }
  // const URL = action.pageFolderId
  //   ? `${requestUrl}?pageFolderId=${action.pageFolderId}`
  //   : requestUrl;

  const authToken = yield select(makeSelectUserToken());
  try {
    const response = yield call(request, url, authToken, {});
    yield put(fetchCategoriesSuccess(response.categories, action.pageFolderId));
  } catch (err) {
    yield put(fetchCategoriesFailed(err));
  }
}

function* updateCategory(action) {
  const authToken = yield select(makeSelectUserToken());

  const requestOptions = {
    method: 'PUT',
    body: JSON.stringify(action.details),
  };

  try {
    const response = yield call(request, requestUrl, authToken, requestOptions);
    console.log(action.details);
    console.log(response);
    yield put(updateCategorySuccess(response.category));
  } catch (err) {
    yield put(updateCategoryFailed(err));
  }
}

function* deleteCategory(action) {
  const authToken = yield select(makeSelectUserToken());
  const requestUrl = `category/${action.details._id}`;
  const requestOptions = {
    method: 'DELETE',
    body: JSON.stringify(action.details),
  };
  try {
    yield call(request, requestUrl, authToken, requestOptions);
    yield put(deleteCategorySuccess(action.details._id));
  } catch (err) {
    yield put(updateCategoryFailed(err));
  }
}

function* linkLogo(action) {
  const authToken = yield select(makeSelectUserToken());
  let URL = `${requestUrl}/${action.logoId}/linkLogo`;
  if (action.remove) {
    URL = `${URL}?r=true`;
  }
  const requestOptions = {
    method: 'PUT',
    body: JSON.stringify({categoryId: action.categoryId}),
  };

  try {
    const response = yield call(request, URL, authToken, requestOptions);
    yield put(linkLogoSuccess(response.logo));
  } catch (err) {
    yield put(linkLogoFailed(err));
  }
}

function* updateSequence(action) {
  const authToken = yield select(makeSelectUserToken());
  const URL = `${requestUrl}/categorySequence`;
  const requestOptions = {
    method: 'PUT',
    body: JSON.stringify(action.details),
  };

  try {
    const response = yield call(request, URL, authToken, requestOptions);
    yield put(updateSequenceSuccess(response.categories));
  } catch (err) {
    yield put(updateSequenceFailed(err));
  }
}

function* addCategory(action) {
  const authToken = yield select(makeSelectUserToken());

  const requestOptions = {
    method: 'POST',
    body: JSON.stringify(action.details),
  };

  try {
    const response = yield call(request, requestUrl, authToken, requestOptions);
    yield put(AddCategorySuccess(response.category));
  } catch (err) {
    yield put(AddCategoryFailed(err));
  }
}

function* fetchFolders(action) {
  const authToken = yield select(makeSelectUserToken());
  const params = getQueryString(action.filters);

  const URL = `category/folders?${params}`;

  try {
    const response = yield call(request, URL, authToken, {});
    yield put(fetchFoldersSuccess(response.folders, response.total));
  } catch (err) {
    yield put(fetchFoldersFailed(err));
  }
}

function* fetchFolder(action) {
  const authToken = yield select(makeSelectUserToken());
  const URL = `category/folders/${action.uniqueId}`;

  try {
    const response = yield call(request, URL, authToken, {});
    yield put(fetchFolderSuccess(response.folder));
  } catch (err) {
    yield put(fetchFolderFailed(err));
  }
}

export default function* categoriesSagas() {
  yield all([
    takeEvery(FETCH_CATEGORIES, fetchCategories),
    takeLatest(ADD_CATEGORY, addCategory),
    takeLatest(UPDATE_CATEGORY, updateCategory),
    takeLatest(DELETE_CATEGORY, deleteCategory),
    takeLatest(LINK_LOGO, linkLogo),
    takeLatest(UPDATE_SEQUENCE, updateSequence),
    takeLatest(FETCH_FOLDERS, fetchFolders),
    takeLatest(FETCH_FOLDER, fetchFolder),
  ]);
}
